export function getMeasureFormat(num) {
    if (num < 1000) {
      return num
    } else if(num >= 1000 && num < 1000000) {
      return Math.floor((num/1000) * 100) / 100 + 'K';
    } else if(num >= 1000000 && num < 1000000000) {
      return Math.floor((num/1000000) * 100) / 100 + 'M';
    } else {
      return Math.floor((num/1000000000) * 100) / 100 + 'B';
    }
  }

export function isIOS() {
    var isiOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    return isiOS;
  }

export function isIpad() {
    // Second condition is for IPad Pro
    return (/iPad/i.test(navigator.platform)
      || (/Macintosh/.test(navigator.userAgent) && 'ontouchend' in document));
  }
  
  export function isMobile() {
    const isAndroid = /Android/i.test(navigator.userAgent);
    const isiOS = /iPhone/i.test(navigator.userAgent);
    return isAndroid || isiOS;
  }

export function safeParse(key) {
    const item = localStorage.getItem(key);
    if (!item || item === 'undefined' || item === 'null') return null;

    try {
        return JSON.parse(item);
    } catch (e) {
        console.error(`Failed to parse localStorage item: ${key}`, e);
        return null;
    }
}